"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modalWidth = {
    small: 414,
    medium: 862,
    large: 1312
};
//# sourceMappingURL=constant.js.map